import { createReducer, on } from '@ngrx/store';

import * as fromPersistedStateActions from '../actions/persisted-state.actions';
import * as fromSettingActions from '../actions/setting.actions';

export const dataPortalFeatureKey = 'dataPortal';

export interface State {
  logoUrl: string | null;
  name: string | null;
  url: string | null;
}

export const initialState: State = {
  logoUrl: null,
  name: null,
  url: null
};

export const reducer = createReducer(
  initialState,
  on(
    fromSettingActions.updateReferralCodeSuccess,
    fromSettingActions.loadSettingsSuccess,
    fromSettingActions.refreshReferralCodeSuccess,
    fromPersistedStateActions.migratePersistedOldStateReferralCodeSuccess,
    (state, { payload }) => ({
      ...state,
      logoUrl: payload.data.dataPortal.url,
      name: payload.data.dataPortal.name,
      url: payload.data.dataPortal.url
    })
  ),
  on(
    fromSettingActions.loadSettingsReset,
    fromPersistedStateActions.loadPersistedStateFailure,
    fromPersistedStateActions.persistedStateReset,
    (state) => ({
      ...state,
      logoUrl: null,
      name: null,
      url: null
    })
  ),
  on(fromPersistedStateActions.loadPersistedStateSuccess, (state, { payload }) => ({
    ...state,
    ...payload[dataPortalFeatureKey]
  }))
);
